export const CONNECT_TO_XERO = 'CONNECT_TO_XERO';
export const DISCONNECT_TO_XERO = 'DISCONNECT_TO_XERO';
export const GET_XERO_ACCOUNTS = 'GET_XERO_ACCOUNTS';
export const SET_XERO_ACCOUNTS = 'SET_XERO_ACCOUNTS';
export const SAVE_XERO_ACCOUNTS = 'SAVE_XERO_ACCOUNTS';
export const GET_XERO_TAX_RATES = 'GET_XERO_TAX_RATES';
export const SET_XERO_TAX_RATES = 'SET_XERO_TAX_RATES';
export const SAVE_XERO_TAX_RATES = 'SAVE_XERO_TAX_RATES';
export const GET_PAYMENT_TYPES_XERO = 'GET_PAYMENT_TYPES_XERO';
export const SET_PAYMENT_TYPES_XERO = 'SET_PAYMENT_TYPES_XERO';
export const GET_TILL_MOVEMENT_TYPES_XERO = 'GET_TILL_MOVEMENT_TYPES_XERO';
export const SET_TILL_MOVEMENT_TYPES_XERO = 'SET_TILL_MOVEMENT_TYPES_XERO';
export const GET_TAX_GROUP_XERO = 'GET_TAX_GROUP_XERO';
export const SET_TAX_GROUP_XERO = 'SET_TAX_GROUP_XERO';
export const MANUAL_SYNC = 'MANUAL_SYNC';

// export const XEROACCOUNTTYPE_BANK = 'BANK';
export const XEROACCOUNTTYPE_CURRENT_ASSET = 'CURRENT';
export const XEROACCOUNTTYPE_CURRENT_LIAB = 'CURRLIAB';
export const XEROACCOUNTTYPE_DEPRICIATION = 'DEPRECIATN';
export const XEROACCOUNTTYPE_DIRECT_COSTS = 'DIRECTCOSTS';
export const XEROACCOUNTTYPE_EQUITY = 'EQUITY';
export const XEROACCOUNTTYPE_EXPENSE = 'EXPENSE';
export const XEROACCOUNTTYPE_FIXED = 'FIXED';
export const XEROACCOUNTTYPE_INVENTORY_ASSET = 'INVENTORY';
export const XEROACCOUNTTYPE_LIABILITY = 'LIABILITY';
export const XEROACCOUNTTYPE_NONCURRENT_ASSET = 'NONCURRENT';
export const XEROACCOUNTTYPE_OTHER_INCOME = 'OTHERINCOME';
export const XEROACCOUNTTYPE_OVERHEAD = 'OVERHEADS';
export const XEROACCOUNTTYPE_PREPAYMENT = 'PREPAYMENT';
export const XEROACCOUNTTYPE_REVENUE = 'REVENUE';
export const XEROACCOUNTTYPE_SALE = 'SALES';
export const XEROACCOUNTTYPE_NONCURRENT_LIAB = 'TERMLIAB';
export const XEROACCOUNTTYPE_PAYG_LIABILITY = 'PAYGLIABILITY';
export const XEROACCOUNTTYPE_SUPER_ANNUATION_EXPENSE = 'SUPERANNUATIONEXPENSE';
export const XEROACCOUNTTYPE_SUPER_ANNUATION_LIABILITY = 'SUPERANNUATIONLIABILITY';
export const XEROACCOUNTTYPE_WAGES_EXPENSE = 'WAGESEXPENSE';

export const ALL_ACCOUNT_TYPES = [
  // XEROACCOUNTTYPE_BANK,
  XEROACCOUNTTYPE_CURRENT_ASSET,
  XEROACCOUNTTYPE_CURRENT_LIAB,
  XEROACCOUNTTYPE_DEPRICIATION,
  XEROACCOUNTTYPE_DIRECT_COSTS,
  XEROACCOUNTTYPE_EQUITY,
  XEROACCOUNTTYPE_EXPENSE,
  XEROACCOUNTTYPE_FIXED,
  XEROACCOUNTTYPE_INVENTORY_ASSET,
  XEROACCOUNTTYPE_LIABILITY,
  XEROACCOUNTTYPE_NONCURRENT_ASSET,
  XEROACCOUNTTYPE_OTHER_INCOME,
  XEROACCOUNTTYPE_OVERHEAD,
  XEROACCOUNTTYPE_PREPAYMENT,
  XEROACCOUNTTYPE_REVENUE,
  XEROACCOUNTTYPE_SALE,
  XEROACCOUNTTYPE_NONCURRENT_LIAB,
  XEROACCOUNTTYPE_PAYG_LIABILITY,
  XEROACCOUNTTYPE_SUPER_ANNUATION_EXPENSE,
  XEROACCOUNTTYPE_SUPER_ANNUATION_LIABILITY,
  XEROACCOUNTTYPE_WAGES_EXPENSE,
];

export const PAYMENT_ACCOUNTS = [
  // XEROACCOUNTTYPE_BANK,
  XEROACCOUNTTYPE_LIABILITY,
  XEROACCOUNTTYPE_EQUITY,
];
